module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("dwsCK"))).then(() => parcelRequire('f4eak'));